export const otpModalConstants = {
  heading: '#### A one time pin code was sent to your mobile number',
  subheading: 'Please enter the code below',
}
